import { Component, OnInit } from '@angular/core';
import { OAuth2Service } from '@app/services/oauth2.service';

@Component({
  selector: 'app-bcc-federation',
  templateUrl: './bcc.component.html',
  styleUrls: ['./bcc.component.scss'],
  standalone: false,
})
export class BccFederationComponent implements OnInit {
  constructor(private oAuth2Service: OAuth2Service) {}

  ngOnInit(): void {
    // Avvia subito il flusso di login federato verso BCC
    this.oAuth2Service.loginWithBccFederation();
  }
}

